module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"log":{"network":{"agent":"Network"}}},"ru":{"log":{"network":{"title":"Сеть"}}}}')
  delete Component.options._Ctor
}
